import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hidden sm:block" }
const _hoisted_2 = {
  autocomplete: "off",
  class: "flex flex-col gap-4"
}
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_9 = { class: "mt-4 grid grid-cols-2 gap-4" }

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { FilterIcon } from '@heroicons/vue/solid';

import { UiButton, UiMultiselect, UiRightPanel } from '@/components';
import type { AuraProcessingCostsFilters } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraProcessingCostsFilters',
  props: {
    modelValue: {},
    users: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { t } = useI18n();

const filtersOpened = ref(false);
const typeOptions = computed(() => [
    { label: t('aura.processingCosts.processingTypes.summary'), value: 'summary' },
    { label: t('aura.processingCosts.processingTypes.chunking'), value: 'chunking' },
    { label: t('aura.processingCosts.processingTypes.embedding'), value: 'embedding' },
    { label: t('aura.processingCosts.processingTypes.indexing'), value: 'indexing' },
    {
        label: t('aura.processingCosts.processingTypes.insight_extraction'),
        value: 'insight_extraction',
    },
    { label: t('aura.processingCosts.processingTypes.rag_engine'), value: 'rag_engine' },
    { label: t('aura.processingCosts.processingTypes.sql_engine'), value: 'sql_engine' },
    {
        label: t('aura.processingCosts.processingTypes.free_sql_agent'),
        value: 'free_sql_agent',
    },
    {
        label: t('aura.processingCosts.processingTypes.free_sql_narration'),
        value: 'free_sql_narration',
    },
    {
        label: t('aura.processingCosts.processingTypes.answer_generation'),
        value: 'answer_generation',
    },
    {
        label: t('aura.processingCosts.processingTypes.answer_agent_reasoning'),
        value: 'answer_agent_reasoning',
    },
    { label: t('aura.processingCosts.processingTypes.classify'), value: 'classify' },
    {
        label: t('aura.processingCosts.processingTypes.memory_summarize'),
        value: 'memory_summarize',
    },
    {
        label: t('aura.processingCosts.processingTypes.tenant_usage_limit'),
        value: 'tenant_usage_limit',
    },
    {
        label: t('aura.processingCosts.processingTypes.provider_rate_limit'),
        value: 'provider_rate_limit',
    },
    {
        label: t('aura.processingCosts.processingTypes.insight_catalog_selection'),
        value: 'insight_catalog_selection',
    },
    {
        label: t('aura.processingCosts.processingTypes.analytical_generation'),
        value: 'analytical_generation',
    },
    {
        label: t('aura.processingCosts.processingTypes.chain_loop_guard'),
        value: 'chain_loop_guard',
    },
    {
        label: t('aura.processingCosts.processingTypes.chain_budget_guard'),
        value: 'chain_budget_guard',
    },
    { label: t('aura.processingCosts.processingTypes.llm_invoke'), value: 'llm_invoke' },
]);
const statusOptions = computed(() => [
    { label: t('aura.processingCosts.statuses.completed'), value: 'completed' },
    { label: t('aura.processingCosts.statuses.failed'), value: 'failed' },
    { label: t('aura.processingCosts.statuses.skipped'), value: 'skipped' },
    { label: t('aura.processingCosts.statuses.pending'), value: 'pending' },
    { label: t('aura.processingCosts.statuses.processing'), value: 'processing' },
]);

const update = (changes: AuraProcessingCostsFilters) =>
    emit('update:modelValue', { ...props.modelValue, ...changes, page: 1 });

const clearFilters = () =>
    update({ userId: undefined, processingType: undefined, status: undefined });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UiRightPanel), {
    modelValue: filtersOpened.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filtersOpened).value = $event)),
    title: _ctx.$t('filter.sidebar.title')
  }, {
    button: _withCtx(() => [
      _createVNode(_unref(UiButton), {
        size: "md",
        variant: "white",
        "text-variant": "gray-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (filtersOpened.value = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FilterIcon), {
            class: "mr-0 h-5 w-5 text-gray-400 sm:mr-3",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('core.actions.Filter')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('aura.processingCosts.filters.userLabel')), 1),
          _createVNode(_unref(UiMultiselect), {
            name: "processing_costs_user",
            "model-value": _ctx.modelValue.userId,
            options: _ctx.users,
            label: "name",
            "value-prop": "id",
            primitive: "",
            "can-clear": "",
            placeholder: _ctx.$t('core.options.All'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (update({ userId: $event || undefined })))
          }, null, 8, ["model-value", "options", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('aura.processingCosts.filters.typeLabel')), 1),
          _createVNode(_unref(UiMultiselect), {
            name: "processing_costs_type",
            "model-value": _ctx.modelValue.processingType,
            options: typeOptions.value,
            label: "label",
            "value-prop": "value",
            primitive: "",
            "can-clear": "",
            placeholder: _ctx.$t('core.options.All'),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (update({ processingType: $event || undefined })))
          }, null, 8, ["model-value", "options", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('aura.processingCosts.filters.statusLabel')), 1),
          _createVNode(_unref(UiMultiselect), {
            name: "processing_costs_status",
            "model-value": _ctx.modelValue.status,
            options: statusOptions.value,
            label: "label",
            "value-prop": "value",
            primitive: "",
            "can-clear": "",
            placeholder: _ctx.$t('core.options.All'),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (update({ status: $event || undefined })))
          }, null, 8, ["model-value", "options", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(UiButton), {
            variant: "white",
            "text-variant": "gray-700",
            onClick: clearFilters
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Clear')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(UiButton), {
            variant: "primary",
            "text-variant": "white",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (filtersOpened.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Apply')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})